import { IMessageTree, Role } from '../api/llmapi';

export class Message {
    place?     : number;
    index      : number;
    content    : string;
    rating     : number;
    role       : Role;
    timestamp  : Date;
    parent     : Message | undefined;
    reply      : Message | undefined;
    replies    : Message[];
    showCursor : boolean;

    constructor(role : Role, content : string)
    {
        this.showCursor = false;
        this.rating     = 0;
        this.index      = 0;
        this.replies    = [];
        this.role       = role;
        this.content    = content;
        this.timestamp  = new Date();
    }

    addReply(message : Message)
    {
        message.index  = this.replies.length;
        message.parent = this;
        this.replies.push(message);
        this.reply   = message;
    }

    canTrain() : boolean
    {
        if (!this.parent) {
            return false;
        }

        if (this.parent.replies.length < 2) {
            return false;
        }

        for (let i = 0; i < this.parent.replies.length; i++) {
            if (this.parent.replies[i].rating === 0) {
                return false;
            }
        }

        return true;
    }

    deleteChild(msg : Message)
    {
        let index = this.replies.indexOf(msg);
        if (index > -1) {
            this.replies.splice(index, 1);

            if (this.replies.length === 0) {
                this.reply = undefined;
            }
            else {
                for (let i = 0; i < this.replies.length; i++) {
                    this.replies[i].index = i;
                }

                if (this.reply === msg) {
                    if (index >= this.replies.length) {
                        index = this.replies.length - 1;
                    }

                    this.reply = this.replies[index];
                }
            }
        }
    }

    getPriorMessages() : Message[]
    {
        if (this.parent === undefined) {
            return [];
        }
        else {
            let messages = this.parent.getPriorMessages();
            messages.push(this.parent);
            return messages;
        }
    }

    getReply() : Message | undefined
    {
        return this.reply;
    }

    getReplies() : Message[]
    {
        return this.replies;
    }

    getSiblings() : number
    {
        if (this.parent === undefined) {
            return 1;
        }
        else {
            return this.parent.replies.length;
        }
    }

    static load(tree : IMessageTree) : Message
    {
        let root       = new Message(tree.role, tree.content);
        root.rating    = tree.rating;
        root.timestamp = new Date(tree.timestamp);

        const n = tree.replies.length;
        for (let i = 0; i < n; i++) {
            let child = Message.load(tree.replies[i]);
            child.index  = i;
            child.parent = root;
            root.replies.push(child);
            if (i === tree.selected) {
                root.reply = child;
            }
        }

        return root;
    }

    replaceReply(message : Message)
    {
        message.index               = this.replies.length - 1;
        message.parent              = this;
        this.replies[message.index] = message;
        this.reply                  = message;
    }

    toJson() : IMessageTree
    {
        let selectedReply = -1;
        let replies : IMessageTree[] = [];

        for (let i = 0; i < this.replies.length; i++) {
            let reply = this.replies[i];
            if (reply === this.reply) {
                selectedReply = i;
            }
            replies.push(reply.toJson());
        }

        return {
            "role"      : this.role,
            "content"   : this.content,
            "rating"    : this.rating,
            "timestamp" : this.timestamp.toISOString(),
            "selected"  : selectedReply,
            "replies"   : replies
        };
    }

    selectSibling(index : number)
    {
        if (this.parent === undefined) {
            return;
        }
        if (index >= 0 && index < this.parent.replies.length) {
            this.parent.reply = this.parent.replies[index];
        }
    }

}

